'use es6';

import { PureComponent, Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultValueLabel = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'editor.form.config.selectCheckbox.label'
});
const DefaultValueTooltip = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'editor.form.config.selectCheckbox.tooltip'
});
const CheckboxRadioInput = ({
  helpIconTitleKey,
  radioLabelTextKey,
  radioValue,
  onChange,
  currentValue
}) => /*#__PURE__*/_jsx(RadioInput, {
  descriptionLayout: "horizontal",
  checked: currentValue === radioValue,
  description: /*#__PURE__*/_jsx(HelpIcon, {
    tooltipPlacement: "right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: helpIconTitleKey
    })
  }),
  onChange: () => onChange(radioValue),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: radioLabelTextKey
  })
});
const DefaultValueSelect = ({
  onChange,
  value,
  field
}) => /*#__PURE__*/_jsx(CommentableArea, {
  moduleId: `${getPropertyObjectTypeId(field)}-default-value`,
  description: {
    translationKey: 'formsDefaultValue'
  },
  children: /*#__PURE__*/_jsx("div", {
    "data-test-id": "config-input-field",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(DefaultValueLabel, {}),
      tooltip: /*#__PURE__*/_jsx(DefaultValueTooltip, {}),
      tooltipPlacement: "top right",
      children: /*#__PURE__*/_jsxs(ToggleGroup, {
        name: "my-field-name",
        id: "single-checkbox-state",
        "data-editable-field": "single-checkbox-state",
        children: [/*#__PURE__*/_jsx(CheckboxRadioInput, {
          helpIconTitleKey: 'editor.form.config.selectCheckbox.unselectedDescription',
          radioLabelTextKey: 'editor.form.config.selectCheckbox.unselected',
          radioValue: undefined,
          onChange: onChange,
          currentValue: value
        }), /*#__PURE__*/_jsx(CheckboxRadioInput, {
          helpIconTitleKey: 'editor.form.config.selectCheckbox.trueDescription',
          radioLabelTextKey: 'editor.form.config.selectCheckbox.truthy',
          radioValue: 'true',
          onChange: onChange,
          currentValue: value
        }), /*#__PURE__*/_jsx(CheckboxRadioInput, {
          helpIconTitleKey: 'editor.form.config.selectCheckbox.falseDescription',
          radioLabelTextKey: 'editor.form.config.selectCheckbox.falsy',
          radioValue: 'false',
          onChange: onChange,
          currentValue: value
        })]
      })
    })
  })
});
const DefaultValueSelectContainer = ({
  formUpdate = () => {},
  field,
  field: {
    hidden = false,
    selectedOptions = []
  } = {}
}) => {
  const onChange = changedVal => formUpdate(updateFormFieldKey(field, FormFieldKeys.SELECTED_OPTIONS, changedVal ? [changedVal] : []));
  const shouldShowDefaultValueWarning = hidden && !selectedOptions[0];
  const value = selectedOptions[0];
  return /*#__PURE__*/_jsx(DefaultValueSelect, {
    onChange: onChange,
    shouldShowDefaultValueWarning: shouldShowDefaultValueWarning,
    value: value,
    field: field
  });
};
export default class Checkbox extends PureComponent {
  render() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, this.props.HiddenField, this.props.LabelField, /*#__PURE__*/_jsx(Spacer, {}), this.props.HelpTextField, /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(DefaultValueSelectContainer, {
        formUpdate: update,
        field: field
      }), /*#__PURE__*/_jsx(Spacer, {}), this.props.ProfillingField]
    });
  }
}